import React from 'react'
import ReactDOM, { type Root } from 'react-dom/client'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { RouterProvider } from '@tanstack/react-router'
import { AuthProvider } from '@modules/auth/AuthProvider'
import { router } from './router'
import theme from './theme'

type RootElement = HTMLElement & { __portalReactRoot?: Root }

const rootElement = document.getElementById('root') as RootElement | null
if (!rootElement) {
  throw new Error('Root element not found')
}

const reactRoot = rootElement.__portalReactRoot ?? ReactDOM.createRoot(rootElement)
rootElement.__portalReactRoot = reactRoot

reactRoot.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
